import React, { useContext, useEffect } from 'react';
import styles from './commodityDistribution.module.scss';
import CardWithStickyHeader, {
  ButtonProps,
} from 'shared/components/CardWithStickyHeader';
import {
  actionButtons,
  farmStagesTitles,
} from 'constants/FarmboxConstants/stage0.constants';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import { ButtonType } from 'enums/ButtonEnums';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { stage5Fields } from 'constants/FarmboxConstants/stage5.constants';
import { Col, Row } from 'antd';
import FieldsRow from 'shared/components/FieldsRow';
import { FormType } from 'enums/FieldTypeEnums';
import { getTotalQuantityFormData } from './commodityDistributionLayoutData';
import EndMarketLocationFields from './EndMarketLocationFields';
import {
  EndMarketLocations,
  FarmBoxCommodityDestribution,
} from 'models/FarmBoxCommodityDestribution/farmBoxCommodityDestribution.model';
import FarmboxCommodityDistributionService from 'services/Farmbox/CommodityDistribution/commodityDistribution.service';
import { useParams, useSearchParams } from 'react-router-dom';
import useFarmboxRedirections from 'shared/utils/useFarmboxRedirections';
import isProductDisabled from 'shared/utils/isProductDisabled';
import { HelpDeskContext } from 'context/HelpDeskContext';

const FarmCommodityDistribution = () => {
  const { control, handleSubmit, reset } = useFormContext();
  const {
    loading,
    updateCommodityDistribution,
    getCommodityDistribution,
    buttonLoading,
  } = FarmboxCommodityDistributionService();

  const { redirectToCommodityOverview, redirectToFarmField } = useFarmboxRedirections();
  const { id: commodityId, status } = useParams();
  const [searchParams] = useSearchParams();
  const { setIsHelpDeskOpen } = useContext(HelpDeskContext);
  const queryParams = Object.fromEntries(searchParams.entries());
  useEffect(() => {
    fetchCommodityDistribution();
  }, []);
  // for reset the default values of form
  const fetchCommodityDistribution = async () => {
    const commodityDistribution = await getCommodityDistribution(
      Number(commodityId)
    );
    const isRoutesPresent = commodityDistribution?.routes?.length;
    const defaultValues = commodityDistribution
      ? !isRoutesPresent
        ? { ...commodityDistribution, routes: [new EndMarketLocations()] }
        : commodityDistribution
      : new FarmBoxCommodityDestribution();
    reset(defaultValues);
  };
  const { PRODUCT_OVERVIEW } = farmStagesTitles;
  const { ADD_END_MORKET_LOCATION, TOTAL } = actionButtons;
  const { TEXT, PRIMARY } = ButtonType;
  const { ROUTES } = stage5Fields;
  const isDisabled = isProductDisabled(status);
  const { fields, append, remove } = useFieldArray({
    control: control,
    name: ROUTES,
  });
  const handleAddEndMarket = async () =>
    append(new EndMarketLocations(), { shouldFocus: false });
  const handleFormSubmit = async (data: FarmBoxCommodityDestribution) => {
    if (!isDisabled) {
      const success = await updateCommodityDistribution(
        Number(commodityId),
        data
      );
      if (success)
        redirectToCommodityOverview(Number(commodityId), status, queryParams);
    } else {
      redirectToCommodityOverview(Number(commodityId), status, queryParams);
    }
  };
  const actionButtonsList: ButtonProps[] = [
    {
      icon: <AddIcon />,
      title: ADD_END_MORKET_LOCATION,
      clickCallback: handleAddEndMarket,
      type: TEXT,
      isAdd: true,
    },
    {
      icon: <ArrowRightOutlined />,
      title: TOTAL,
      clickCallback: handleSubmit(handleFormSubmit),
      type: PRIMARY,
      isAdd: false,
      loading: buttonLoading,
    },
  ];

  const totalQuantityFormData = getTotalQuantityFormData();
  const handleBackNavigation = () => {
    setIsHelpDeskOpen(false);
    redirectToFarmField(Number(commodityId), status, queryParams);
  };
  return (
    <div className={styles.farmCommodityDistributionContainer}>
      <CardWithStickyHeader
        title={PRODUCT_OVERVIEW}
        actionButtons={actionButtonsList}
        backCallback={handleBackNavigation}
        loading={loading}>
        <div className={styles.farmElementContainer}>
          <Row>
            <Col span={24}>
              <FieldsRow
                {...totalQuantityFormData}
                formType={FormType.REACT_HOOK_FORMS}
              />
            </Col>
          </Row>
          {fields?.map((field, index) => (
            <div key={field.id} className={styles.fieldsContainer}>
              <EndMarketLocationFields
                index={index}
                remove={remove}
                isDisabled={isDisabled}
              />
            </div>
          ))}
        </div>
      </CardWithStickyHeader>
    </div>
  );
};

export default FarmCommodityDistribution;
